import './Lands.css';
import { isMapSectionColored } from '../../../../domain';
import { useAppStore } from '../../../store/appStore';
import { LAND_PLACEMENTS, mapPaintBoxStyle } from './landPositions';
import { LAND_IMAGES } from './mapLandAssets';
import { giantIdForLand } from './landGiantIds';

/**
 * Map land/sea PNGs, placed by Figma Frame 2 coords.
 * Color when the land's giant was ever offered a delivery (sticky unlock).
 */
export function Lands() {
  const playerEconomy = useAppStore((s) => s.playerEconomy);

  return (
    <>
      {LAND_PLACEMENTS.map((land) => {
        const isColored = isMapSectionColored(playerEconomy, giantIdForLand(land.id));

        return (
          <div
            key={land.id}
            className={
              isColored
                ? 'map-lands__land'
                : 'map-lands__land map-lands__land--grayscale'
            }
            aria-hidden
            style={mapPaintBoxStyle(land.left, land.top, land.width, land.height)}
          >
            <img
              className="map-lands__land-img"
              src={LAND_IMAGES[land.id]}
              alt=""
              draggable={false}
            />
          </div>
        );
      })}
    </>
  );
}
